import React from "react"
import PropTypes from "prop-types"

import theme from "styles/theme"

const StatCard = ({
  figure,
  description,
  footnote,
  condensed = false,
  className,
}) => (
  <div
    css={{
      backgroundColor: theme.white,
      borderBottom: `6px solid ${theme.midBlue}`,
      maxWidth: 360,
      padding: `0 ${condensed ? 26 : 32}px 20px`,
      [theme.tablet]: {
        padding: "0 30px 20px",
      },
      [theme.mobile]: {
        padding: "0 20px 20px",
        borderBottomWidth: 5,
      },
    }}
    className={className}
  >
    <div
      css={{
        ...theme.statValue,
        display: "inline-block",
        borderTop: `26px solid ${theme.blue20}`,
        paddingTop: 5,
        color: theme.midBlue,
        marginBottom: condensed ? 30 : 38,
        [theme.mobile]: {
          marginBottom: 21,
        },
      }}
    >
      {figure}
    </div>

    <div
      css={{
        ...theme.statDescription,
        color: theme.darkGray,
      }}
    >
      {description}
    </div>

    {footnote && (
      <div
        css={{
          ...theme.statFootnote,
          color: theme.gray,
          marginTop: 18,
          [theme.mobile]: {
            marginTop: 6,
          },
        }}
      >
        {footnote}
      </div>
    )}
  </div>
)

StatCard.propTypes = {
  figure: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  footnote: PropTypes.string,
  condensed: PropTypes.bool,
  className: PropTypes.string,
}

export default StatCard
